import { ChemicalComponent } from "@/services/chemical-component"
import { Col, Menu, Modal, ModalProps, Row } from "antd"
import { useMemo, useState } from "react"
import { AdminForm } from "./forms/AdminForm"
import { createRoot } from "react-dom/client"
import styles from "./index.module.less";
import classNames from "classnames"
import { GeneralForm } from "./forms/GeneralForm"
import { HeatCapacityForm } from "./forms/HeatCapacityForm"
import { AntoineForm } from "./forms/AntoineForm"
import { PengRobinsonForm } from "./forms/PengRobinsonForm"


interface AddEditComponentProps extends ModalProps {
  onSuccess?: () => void
  component?: ChemicalComponent.Modal
  orgId?: number
}

export const AddEditComponent = (props: AddEditComponentProps) => {
  const {onCancel, component, onSuccess, orgId} = props
  const [activeKey, setActiveKey] = useState('admin')

  const sections = useMemo(() => {
    return [
      {
        key: 'admin',
        label: 'Admin',
        component: AdminForm
      },
      {
        key: 'general',
        label: 'General',
        disabled: !component,
        component: GeneralForm
      },
      {
        key: 'heat_capacity',
        label: 'Heat Capacity',
        disabled: !component,
        component: HeatCapacityForm,
      },
      {
        key: 'antoine',
        label: 'Antoine',
        disabled: !component,
        component: AntoineForm
      },
      {
        key: 'pr-twu',
        label: 'Peng-Robinson TWU',
        disabled: !component,
        component: PengRobinsonForm
      },
    ]
  }, [component])

  const section = useMemo(()=> {
    return sections.find(item => item.key === activeKey);
  }, [activeKey])

  const toCreate = (values) => {
    if (orgId) {
      return ChemicalComponent.OrganizationService.create(orgId, values)
    }
    return ChemicalComponent.AdminService.create(values)
  }

  const toUpdate = (values, component) => {
    const newVal = {...component, ...values}
    delete newVal.id
    if (orgId) {
      return ChemicalComponent.OrganizationService.update(orgId, component.id, newVal)
    }
    return ChemicalComponent.AdminService.update(component.id, newVal)
  }

  const onSave = async (val) => {
    if (!component) {
      await toCreate(val)
    } else {
      await toUpdate(val, component)
    }

    onSuccess?.()
  }

  const SectionFormComp = section!.component

  return <Modal
    width={1200}
    open={true}
    maskClosable={false}
    onCancel={onCancel}
    footer={null}
  >
    <Row gutter={24}>
      <Col span={6}>
        <Menu
          activeKey={activeKey}
          items={sections}
          selectedKeys={[activeKey]}
          onSelect={({ key }) => {
            setActiveKey(key)
          }}
        />
      </Col>
      <Col span={18}>
        <div className={classNames(styles.header, 'px-1')}>{section?.label}</div>
        <div className="px-1 py-1">{SectionFormComp && <SectionFormComp onSave={onSave} onCancel={onCancel} component={component} />}</div>
      </Col>
    </Row>
  </Modal>
}

AddEditComponent.show = (props: AddEditComponentProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<AddEditComponent
    {...props}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
  />);
}